/* ToyZone OOS Pushdown v2 — FIXED infinite loop (2026-10-17)
   Moves sold-out cards to end of grid. The MutationObserver now
   disconnects before reordering to avoid triggering itself. */
(function(){
  if(window.location.pathname.indexOf("/collections/")===-1) return;

  var obs = null;
  var grids = [];

  function pushDown(){
    try{
      document.querySelectorAll(".tz-product-grid").forEach(function(grid){
        var moved = [];
        grid.querySelectorAll(".tz-card.is-sold-out").forEach(function(card){
          if(card.parentElement === grid) moved.push(card);
        });
        if(!moved.length) return;
        // Disconnect observer so our own moves don't re-trigger it
        if(obs) obs.disconnect();
        moved.forEach(function(card){ grid.appendChild(card); });
        // Reconnect after moves are done
        watch();
      });
    }catch(e){}
  }

  function onMut(muts){
    for(var i=0; i<muts.length; i++){
      if(muts[i].addedNodes && muts[i].addedNodes.length){
        pushDown();
        break;
      }
    }
  }

  function watch(){
    if(!obs) obs = new MutationObserver(onMut);
    else obs.disconnect();
    document.querySelectorAll(".tz-product-grid").forEach(function(g){
      obs.observe(g, {childList: true});
    });
  }

  function run(){ pushDown(); }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ run(); watch(); });
  } else {
    run(); watch();
  }
  window.setTimeout(run, 1500);
})();
